import { render, staticRenderFns } from "./Profile01.vue?vue&type=template&id=440778c6&scoped=true&"
import script from "./Profile01.vue?vue&type=script&lang=js&"
export * from "./Profile01.vue?vue&type=script&lang=js&"
import style0 from "./Profile01.vue?vue&type=style&index=0&id=440778c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "440778c6",
  null
  
)

export default component.exports